const store = {
	state: {
		navTitle: "",
		navContent: "",
		content: {}
	},
	changeNavigationData(title, content) {
		this.state.navTitle = title;
		this.state.navContent = content;
	},
	cacheContent(name, data) {
		this.state.content[name] = data;
	}
};

export default store;
